import {
  SDS_MOTION_DURATION_SLOW,
  SDS_MOTION_EASING_DEFAULT,
} from '@s-group/design-system-tokens/web/tokens/motion.es6'

export const MOTION_DURATION_SLOW = SDS_MOTION_DURATION_SLOW
export const MOTION_EASING_DEFAULT = SDS_MOTION_EASING_DEFAULT
